<svg class="w-full h-full">
  <defs>
    <linearGradient id="coinGradient" x1="1" y1="0" x2="0" y2="1">
      <stop offset="5%" stop-color="#0D7C3D" />
      <stop offset="95%" stop-color="#9DBD44" />
    </linearGradient>
  </defs>
  <circle stroke="#EEEEEE" stroke-width="6" fill="transparent" cx="70" cy="70" [attr.r]="radius"></circle>
  <circle
    stroke="url(#coinGradient)"
    stroke-width="6"
    stroke-linecap="round"
    fill="transparent"
    cx="70"
    cy="70"
    transform="rotate(-90 70 70)"
    [attr.stroke-dasharray]="circumference"
    [@progressAnimation]="progressState"
    [attr.r]="radius"
  ></circle>
</svg>
